module.exports = __webpack_public_path__ + "static/media/active_video_thumb4.a21c0251.png";